import { ServiceConfig } from 'shared/models/service-configs';

export const uatServiceConfig: ServiceConfig = {
  clientId: '44f3403a-388d-4107-b90d-95d36f9bbfd8',
  tenantId: 'c9340d0a-8762-4b43-a2d1-f59bd6ef8726',
};
